import React, { Dispatch } from 'react';
import { SearchesState } from './types';
import { TableActionItemAction } from '../Components/GenericTable/types';
import { ICandidateSourcingSearch } from './types';
import Api from './API';

interface CandidateSourcingTableActionComponentsProps {
  actionsState: SearchesState['searchesTableState']['actions'];
  dispatch: Dispatch<TableActionItemAction<ICandidateSourcingSearch>>;
  refetchSearches: () => void;
  onDeleteClick: (search: ICandidateSourcingSearch) => void;
}

const CandidateSourcingTableActionComponents = ({
  actionsState,
  dispatch,
  refetchSearches,
  onDeleteClick
}: CandidateSourcingTableActionComponentsProps) => {
  React.useEffect(() => {
    if (actionsState.isOpen?.delete && actionsState.selectedItem) {
      onDeleteClick(actionsState.selectedItem);
      dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'delete' });
    }
  }, [actionsState.isOpen?.delete, actionsState.selectedItem, onDeleteClick, dispatch]);

  return null;
};

export default CandidateSourcingTableActionComponents;
